/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import { set } from "lodash";
import { F } from "ramda";

/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-unused-expressions */

function handleInitialAdjustments({
  questionnaire,
  externalBrokers,
  thirdParties,
  setFiles,
  setNewFile
}) {
  let attachments = [];
  const questionnaireAnswers = questionnaire.map(question => {
    if (question.idQuestion !== 2143) return question;    
    
    const partyTypeQuestion = question.childrenQuestions.find(qst => qst.idQuestion === 2144);
    
    if (!externalBrokers.length) {
      partyTypeQuestion.answerOptions = filterAnswerOptions(partyTypeQuestion.answerOptions, 7759);
      question.answerOptions = filterAnswerOptions(question.answerOptions, 7768);
      updateChildrenQuestions(question, partyTypeQuestion);
    }
    
    if (!thirdParties.length) {
      partyTypeQuestion.answerOptions = filterAnswerOptions(partyTypeQuestion.answerOptions, 7760);
      question.answerOptions = filterAnswerOptions(question.answerOptions, 7773);
      updateChildrenQuestions(question, partyTypeQuestion);
    }
    question.childrenQuestions.sort((a, b) => a.idQuestion - b.idQuestion);

    if (question.answer !== '' && JSON.parse(question.answer).length > 0) {
      attachments = addAttachmentOnSendFiles({attachments: JSON.parse(question.answer), setFiles, setNewFile});
    }
    
    return question;
  });

  return {
    questionnaireAnswers,
    attachments
  };
};

const addAttachmentOnSendFiles = ({ attachments, setNewFile, setFiles}) => {
  const formattedAttachments = [];
  for (const attachment of attachments) {
    const formattedFile = {
      idDocument: attachment.documentId,
      idPerson: Number(attachment.idPersonDocument),
      idPersonRoot: Number(attachment.idPersonDocument),
      title: attachment.fileName,
    }
    
    setNewFile(formattedFile);
    setFiles((prevFiles) => [...prevFiles, formattedFile]);
    
    formattedAttachments.push(formattedFile);
  }

  return formattedAttachments;
}

const filterAnswerOptions = (answerOptions, idToExclude) =>
  answerOptions.filter(option => option.idAnswerOption !== idToExclude);

const updateChildrenQuestions = (question, updatedQuestion) => {
  question.childrenQuestions = [
    ...question.childrenQuestions.filter(qst => qst.idQuestion !== updatedQuestion.idQuestion),
    updatedQuestion,
  ];
};

async function handleQuestionChange({
  question,
  value,
  questionnaireUpdated,
  setQuestionnaireUpdated,
  setFieldValue,
  globalQuestionnaire,
  files,
  setFiles,
  setNewFile,
  sendFiles,
  setSendFiles,
  setHasContactsParties
}) {

  setHasContactsParties(false);

  if (Array.isArray(value)) {
    for (const file of value) {
      const formattedFile = {
        idDocument: file.documentId,
        idPerson: Number(file.idPersonDocument),
        idPersonRoot: Number(file.idPersonDocument),
        title: file.fileName,
        lnkAccessPdf: file.fileUrl
      }
      setNewFile(formattedFile);
      setFiles((prevFiles) => [...prevFiles, formattedFile]);

    }
  } else {
    const index = value;
    const attachmentQst = globalQuestionnaire.find((q) => q.idQuestion === 2143);
    if (attachmentQst) {
      const { answer } = attachmentQst;
      const file = answer[index];
      const updatedFiles = files.filter(f => f.idDocument !== file.documentId);
      const updatedSendFiles = sendFiles.map((partyFile) => {
        if (partyFile.idPerson === Number(file.idPersonDocument)) {
          return {
            ...partyFile,
            files: partyFile.files.filter(f => f.idDocument !== file.documentId)
          }
        }
        return partyFile
      })
      setSendFiles(updatedSendFiles);
      setFiles(updatedFiles);
    }
  }

};

const events = {
handleInitialAdjustments,
handleQuestionChange
};

export { events };